import ProductCard from "@/components/ProductCard";

// The other pieces of this product's set (Racer), from products the store already has.
export default function ShopTheSet({ pieces }) {
  if (!pieces?.length) return null;
  return (
    <section data-testid="shop-the-set" className="px-6 md:px-12 py-16 md:py-24 border-t border-[#8A8A8A]/20">
      <h2 className="text-xl md:text-2xl font-medium uppercase tracking-[0.2em] text-[#F2F0EB] mb-10">Shop The Set</h2>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-10 sm:gap-x-6">
        {pieces.map((p) => <ProductCard key={p.id} product={p} />)}
      </div>
    </section>
  );
}
